var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('template',{slot:"content"},[[_c('list-group',{attrs:{"title":'設定を変更する'}},[_c('list-item',{attrs:{"spanText":'Q. ',"text":'ランキングに表示されている名前を変更したい',"urlName":'Help34'}})],1)]],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d672035","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/HelpCategory52.vue
// module id = R90c
// module chunks = 0